import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/qualified-census-tracts")({
  component: () => <Outlet />,
});
